<script setup>
import XlButton from '../xl/XlButton.vue';
import IconSparkle from '../icons/IconSparkle.vue';

defineProps({
  text: { type: String, required: true },
  actionLabel: { type: String, default: '' },
  actionTestid: { type: String, default: '' },
});

defineEmits(['action']);
</script>

<template>
  <!--
    The explanation and the tab's one action share a row: an action row holding
    nothing but a right-aligned button costs a whole band of the page to say
    nothing. Anything passed to the default slot lands in that row — which is
    where the Delete that appears once rows are ticked arrives from.
  -->
  <div class="comms-info-banner">
    <p class="comms-info-banner__text" data-testid="comms-banner">
      <IconSparkle /><span>{{ text }}</span>
    </p>
    <XlButton
      v-if="actionLabel"
      :data-testid="actionTestid"
      variant="ghost"
      size="sm"
      @click="$emit('action')"
    >{{ actionLabel }}</XlButton>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.comms-info-banner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  font-family: var(--xl-font-family);

  &__text {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    flex: 1 1 340px;
    margin: 0;
    padding: 11px 14px;
    /* Tighter than the cards below it — the board draws this band at 12px, and
       every Northstar radius token is 18px or more. */
    border-radius: 12px;
    background: var(--xl-color-primary-container);
    color: var(--xl-color-primary);
    font-size: var(--xl-type-body-medium-size);
    line-height: 1.55;
  }

  &__text svg {
    flex: 0 0 auto;
    margin-top: 1px;
  }
}
</style>
